import React from 'react';

export const CloseIcon = () => (
  <svg height="24px" id="Layer_1_close" version="1.1" viewBox="0 0 90 90" width="24px"  xmlns="http://www.w3.org/2000/svg">
    <circle className="st73" cx="45" cy="45" r="45"/><g><g><rect className="st7" height="50.9116898" transform="matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -19.3467178 45.2928925)" width="7.999836" x="41.0000801" y="20.5441551"/></g></g><g><g><rect className="st7" height="7.999836" transform="matrix(0.7071678 -0.7070457 0.7070457 0.7071678 -19.3466549 45.2873383)" width="50.9116898" x="19.5441551" y="42.0000801"/></g></g>
  </svg>
);